const UINT32_RANGE = 0x100000000;

export function normalizeSeed(seed) {
  if (typeof seed === 'number' && Number.isFinite(seed)) {
    const normalized = Math.trunc(seed) >>> 0;
    return normalized || 0x6d2b79f5;
  }

  const text = String(seed ?? 'trading-post');
  let hash = 2166136261;
  for (let index = 0; index < text.length; index += 1) {
    hash ^= text.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return (hash >>> 0) || 0x6d2b79f5;
}

// Mulberry32's entire state is one unsigned integer, which makes it suitable
// for exact JSON save/load continuation.
export function nextUint32(holder) {
  holder.rngState = (holder.rngState + 0x6d2b79f5) >>> 0;
  let value = holder.rngState;
  value = Math.imul(value ^ (value >>> 15), value | 1);
  value ^= value + Math.imul(value ^ (value >>> 7), value | 61);
  return (value ^ (value >>> 14)) >>> 0;
}

export function randomFloat(holder) {
  return nextUint32(holder) / UINT32_RANGE;
}

export function randomInt(holder, minimum, maximum) {
  const min = Math.ceil(minimum);
  const max = Math.floor(maximum);
  if (!Number.isFinite(min) || !Number.isFinite(max) || max < min) {
    throw new RangeError('randomInt requires a valid inclusive range');
  }
  return min + Math.floor(randomFloat(holder) * (max - min + 1));
}

export function chance(holder, probability) {
  return randomFloat(holder) < Math.max(0, Math.min(1, probability));
}

export function pick(holder, values) {
  if (!Array.isArray(values) || values.length === 0) {
    throw new RangeError('pick requires a non-empty array');
  }
  return values[randomInt(holder, 0, values.length - 1)];
}

export function pickWeighted(holder, values, getWeight = (value) => value.weight) {
  if (!Array.isArray(values) || values.length === 0) {
    throw new RangeError('pickWeighted requires a non-empty array');
  }
  const weights = values.map((value) => Math.max(0, Number(getWeight(value)) || 0));
  const total = weights.reduce((sum, weight) => sum + weight, 0);
  if (total <= 0) return values[0];
  let target = randomFloat(holder) * total;
  for (let index = 0; index < values.length; index += 1) {
    target -= weights[index];
    if (target < 0) return values[index];
  }
  return values[values.length - 1];
}

export function forkSeed(seed, label) {
  return normalizeSeed(`${normalizeSeed(seed)}:${String(label)}`);
}
